var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHwHorizontalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Under_Wallet_Layer",
    "data-name": "Under Wallet Layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 414 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #231f20;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Sea_Green_to_Teal);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sea_Green_to_Teal",
    "data-name": "Sea Green to Teal",
    x1: 87.85,
    y1: 98.46,
    x2: 38.42,
    y2: 12.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018c72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Health Wallet Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.64,18a8,8,0,0,0-8,8V83a7,7,0,0,0,7,7h70a7,7,0,0,0,7-7V37a7,7,0,0,0-7-7h-5V20a2.07,2.07,0,0,0-2-2Zm0,4h60v8h-60a4,4,0,0,1,0-8Zm72,61a3,3,0,0,1-3,3h-70a3,3,0,0,1-3-3V32.91a8,8,0,0,0,4,1.09c22.53,0,49.64,0,69,0a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.28,80.33H59.11a2,2,0,0,1-2-2V68H46.76a2,2,0,0,1-2-2V52.93a2,2,0,0,1,2-2h10.3V40.57a2,2,0,0,1,2-2H72.18a2,2,0,0,1,2,2V50.93H84.53a2,2,0,0,1,2,2V66a2,2,0,0,1-2,2H74.28V78.33A2,2,0,0,1,72.28,80.33Zm-11.17-4h9.17V66a2,2,0,0,1,2-2H82.53V54.93H72.18a2,2,0,0,1-2-2V42.57H61.06V52.93a2,2,0,0,1-2,2H48.76V64H59.11a2,2,0,0,1,2,2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.64,18a8,8,0,0,0-8,8V83a7,7,0,0,0,7,7h70a7,7,0,0,0,7-7V37a7,7,0,0,0-7-7h-5V20a2.07,2.07,0,0,0-2-2Zm0,4h60v8h-60a4,4,0,0,1,0-8Zm72,61a3,3,0,0,1-3,3h-70a3,3,0,0,1-3-3V32.91a8,8,0,0,0,4,1.09c22.53,0,49.64,0,69,0a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.28,80.33H59.11a2,2,0,0,1-2-2V68H46.76a2,2,0,0,1-2-2V52.93a2,2,0,0,1,2-2h10.3V40.57a2,2,0,0,1,2-2H72.18a2,2,0,0,1,2,2V50.93H84.53a2,2,0,0,1,2,2V66a2,2,0,0,1-2,2H74.28V78.33A2,2,0,0,1,72.28,80.33Zm-11.17-4h9.17V66a2,2,0,0,1,2-2H82.53V54.93H72.18a2,2,0,0,1-2-2V42.57H61.06V52.93a2,2,0,0,1-2,2H48.76V64H59.11a2,2,0,0,1,2,2Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.45,59.17H121.27V69H118V47h3.3v9.24h12.18V47h3.3V69h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.71,47H158.5V49.9H147v6.43h11.26v2.91H147V66.1H158.5V69H143.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.63,64.45H167.84L166.05,69h-3.63l8.75-22h4.13L184,69h-3.63Zm-9.84-2.93h8.88l-4.45-11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.76,47h3.3V66.1h10V69h-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.85,49.9H203V47H220V49.9h-6.8V69h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.93,59.17H228.75V69h-3.3V47h3.3v9.24h12.18V47h3.3V69h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.06,52l-4.55,17H266l-6.31-22h3.7l4.56,17.66L272.74,47h2.68l4.78,17.66L284.76,47h3.69l-6.27,22h-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.74,64.45H295L293.17,69h-3.63l8.74-22h4.13l8.75,22h-3.63Zm-9.83-2.93h8.88l-4.46-11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.87,47h3.3V66.1h10V69h-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.88,47h3.3V66.1h10V69h-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.89,47h14.78V49.9H357.19v6.43h11.25v2.91H357.19V66.1h11.48V69H353.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.26,49.9h-6.84V47h16.94V49.9h-6.8V69h-3.3Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwHorizontalLogo);
export default __webpack_public_path__ + "static/media/hw_horizontal_logo.e27e16710d0594982468acaa40e6805c.svg";
export { ForwardRef as ReactComponent };